import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

class ResetContextDialog extends Component {
  close() {
    if (!this.props.onClose) {
      return
    }
    this.props.onClose()
  }

  submit() {
    if (!this.props.onSubmit) {
      return
    }
    this.props.onSubmit()
  }

  render() {
    return (<Modal
      data-test-reset-context
      show={this.props.show}
      animation={true}
      onHide={e => this.close()}>
      <Modal.Header closeButton>
        <Modal.Title>回答経過のリセット</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          このタスクに関する回答内容をリセットしてもよろしいですか？
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='light'
          data-test-reset-context-cancel
          onClick={e => this.close()}>
          キャンセル
        </Button>
        <Button
          variant='danger'
          data-test-reset-context-submit
          disabled={this.props.resetting}
          onClick={e => this.submit()}>
          {this.props.resetting ? 'リセットしています...' : 'リセット'}
        </Button>
      </Modal.Footer>
    </Modal>)
  }
}

export default ResetContextDialog
